import { SET_REGIONS_TYPES, CLEAR_REGIONS_TYPES } from '../actions/actionTypes';
import { ReceiverRegionTypesAction } from '../actions/receiver.region.types';
import * as Regions from '../api/receiver';

const intialState: Regions.INrcRegionTypes[] = [];

export type ReceiverRegionTypesState = {
    regionTypes: Regions.INrcRegionTypes[];
};

const RECEIVER_REGIONS_TYPES = (state = intialState, action: ReceiverRegionTypesAction): Regions.INrcRegionTypes[] => {
    switch (action.type) {
        case SET_REGIONS_TYPES:
            return [...state, ...action.payload];
        case CLEAR_REGIONS_TYPES:
            return intialState;
        default:
            return state;
    }
};

export default RECEIVER_REGIONS_TYPES;
